import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { blobsActions } from 'features/blobs';

const useBlob = () => {
  const dispatch = useDispatch();
  const [percent, setPercent] = useState(0);
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState('');

  const createBlob = useCallback(blob => dispatch(blobsActions.createBlob(blob)), [dispatch]);
  const getBlob = useCallback(id => dispatch(blobsActions.getBlob(id)), [dispatch]);

  const onUploadProgress = (progressEvent) => {
    const { loaded, total } = progressEvent;
    setPercent(Math.round((loaded / total)*100))
  }

  const processBlob = ({ file, checksum, localUrl }, callback = null) => {
    const blob = { name: file.name, size: file.size, type: file.type, checksum, file, localUrl, onUploadProgress };
    setLoading(true);
    setFileName(file.name);
    createBlob(blob)
    .then(({ payload, error}) => {
      if (!error) {
        const { blob: { id, url, content_type, filename } } = payload;
        callback({ id, url, content_type, filename })
      }
    })
    .finally(() => {
      setLoading(false);
      setPercent(0);
      setFileName('');
    });
  };

  return { processBlob, getBlob, fileName, percent, loading };
};

export default useBlob;